import styled from "styled-components";

export const PromptHighlight = styled.span`
  color: ${({ theme }) => theme.primary};
`;

export const BenefitList = styled.ul`
  margin: 12px auto 0;
  padding: 12px 16px;
  width: 276px;
  background: ${({ theme }) => theme.backgroundDark};
  border-radius: 4px;
  list-style: none;
  font-size: 0.8em;
  font-family: ${({ theme }) => theme.fontMedium};
  font-weight: 500;
  text-align: left;
  line-height: 1.6;
`;

export const BenefitItem = styled.li`
  display: flex;
  align-items: flex-start;
`;

export const Checkmark = styled.span`
  color: ${({ theme }) => theme.primary};
  margin-right: 8px;
  flex-shrink: 0;
`;
